import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

export async function list({ status = 'Pending', page = 1, count = 50 } = {}, language, timeZone, cancelToken) {
  const params = { status, page, count };
  return wsRequestGet('/admin/play/ambassador-applications', language, timeZone, params, cancelToken);
}

export async function approve(id, language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/play/ambassador-applications/${id}/approve`, language, timeZone, {}, {}, cancelToken);
}

export async function decline(id, language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/play/ambassador-applications/${id}/decline`, language, timeZone, {}, {}, cancelToken);
}
